import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";
import { AuthService } from '@service/auth.service';
import { environment } from '../environments/environment';


@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(public snackBar: MatSnackBar, private authService: AuthService) {}

  ngOnInit(): void {
    this.loadGoogleMaps();

    const token = localStorage.getItem('token');
    if (token && !this.authService.loggedIn()) {
      this.authService.clearSession();
    }
  }

  private loadGoogleMaps(): void {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
    duration: 2000,
    verticalPosition: 'bottom',
    horizontalPosition: 'center',
    });
  }
}
